export default __webpack_public_path__ + "static/media/img-slider-ommerchant-1.08196f40.png";